import { render, staticRenderFns } from "./IdCheckInfoModal.vue?vue&type=template&id=2ec91a40&scoped=true&"
import script from "./IdCheckInfoModal.vue?vue&type=script&lang=js&"
export * from "./IdCheckInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./IdCheckInfoModal.vue?vue&type=style&index=0&id=2ec91a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec91a40",
  null
  
)

export default component.exports